const context = require.context(".", true, /\.(coffee|js)$/);
context.keys().forEach(function (key) {
    context(key);
});